import React from 'react';

interface CollaborationIndicatorProps {
  isConnected: boolean;
  hasUpdates: boolean;
  updateCount: number;
  lastUpdateBy?: string;
  onRefresh?: () => void;
  className?: string;
}

/**
 * Visual indicator for collaboration status and updates
 * Shows connection status, update count, and provides manual refresh
 */
export const CollaborationIndicator: React.FC<CollaborationIndicatorProps> = ({
  // isConnected,
  hasUpdates,
  updateCount,
  lastUpdateBy,
  // onRefresh,
  className = '',
}) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Connection Status */}
      {/* <div className="flex items-center gap-2">
        <div className="relative">
          <div
            className={`w-2 h-2 rounded-full ${
              isConnected ? 'bg-green-500' : 'bg-gray-400'
            }`}
          />
          {isConnected && (
            <div className="absolute inset-0 w-2 h-2 rounded-full bg-green-500 animate-ping" />
          )}
        </div>
        <span className="text-xs text-gray-600">
          {isConnected ? 'Live Updates' : 'Offline'}
        </span>
      </div> */}

      {/* Update Count Badge */}
      {updateCount > 0 && (
        <div className="flex items-center gap-1 animate-fade-in">
          <span className="badge badge-sm badge-primary">{updateCount}</span>
          <span className="text-xs text-gray-600">
            {updateCount === 1 ? 'update' : 'updates'}
          </span>
        </div>
      )}

      {/* Last Update Info */}
      {lastUpdateBy && hasUpdates && (
        <div className="text-xs text-gray-600 animate-slide-down">
          Updated by {lastUpdateBy}
        </div>
      )}

      {/* Refresh Button */}
      {/* {onRefresh && (
        <button
          onClick={onRefresh}
          className="btn btn-xs btn-ghost"
          title="Refresh for latest updates"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </button>
      )} */}
    </div>
  );
};

/**
 * Update animation overlay for form fields
 * Shows a subtle pulse effect when data is updated
 */
export const UpdateAnimationOverlay: React.FC<{
  show: boolean;
  children: React.ReactNode;
}> = ({ show, children }) => {
  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes slide-down {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
        
        .animate-slide-down {
          animation: slide-down 0.3s ease-out;
        }
        
        .update-shimmer {
          background: linear-gradient(90deg, transparent, rgba(34, 197, 94, 0.1), transparent);
          animation: shimmer 1s ease-in-out;
        }
      `}</style>
      <div className="relative">
        {children}
        {show && (
          <div
            className="absolute inset-0 pointer-events-none update-shimmer"
            style={{
              background: 'linear-gradient(90deg, transparent, rgba(34, 197, 94, 0.1), transparent)',
            }}
          />
        )}
      </div>
    </>
  );
};
